import(/* webpackMode: "eager" */ "/vercel/path0/app/event/[eventId]/_components/CopyLinkButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimeInformation"] */ "/vercel/path0/app/event/[eventId]/_components/TimeInformation.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/assets/google.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/BuyButton/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
